import React from 'react';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES,
  coursePauseRequestApproveModalStageSelector,
} from 'features/courseResume';
import CoursePauseRequestApproveModalConfirmStage from '../CoursePauseRequestApproveModalConfirmStage';
import CoursePauseRequestApproveModalSuccessStage from '../CoursePauseRequestApproveModalSuccessStage';

function CoursePauseRequestApproveModalStageRenderer() {
  const modalStage = useSelector(coursePauseRequestApproveModalStageSelector);

  switch (modalStage) {
    case COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.confirm:
      return <CoursePauseRequestApproveModalConfirmStage />;
    case COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.success:
      return <CoursePauseRequestApproveModalSuccessStage />;
    default:
      return null;
  }
}

export default CoursePauseRequestApproveModalStageRenderer;
